// PartyGear.jsx
import React from "react";
import PartyGearStoresList from "../features/store/PartyGearStoresList.jsx";
import GoldAd from "../features/sponsors/GoldAd.jsx";
import Heading from "../ui/Heading.jsx";

function PartyGear({ selectedCountry, selectedCity }) {
    return (
        <div className="min-h-screen bg-gradient-to-br pt-10 px-1.25">
            <div className="text-center mb-12">
                <Heading className="text-center font-bold mb-4">Queer Retail</Heading>
                <p className="text-gray-600 max-w-2xl mx-auto">
                    Discover unique queer-friendly spaces across Australia for fashion,
                    entertainment, party gear, toys, accessories and more!
                </p>
            </div>


            <GoldAd sponsorId="cabinetbar-mel"
                    selectedCountry={selectedCountry}
                    selectedCity={selectedCity}/>

            <PartyGearStoresList
                
                selectedCountry={selectedCountry}
                selectedCity={selectedCity}
            />

        </div>
    );
}

export default PartyGear;
